import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Registra una acción de auditoría en Firestore de manera asíncrona y segura.
 * No bloquea la ejecución de la UI.
 */
export const logAuditAction = async ({ userId, userName, modulo, accion, descripcion }) => {
    try {
        await addDoc(collection(db, 'logs_auditoria'), {
            timestamp: serverTimestamp(),
            uID: userId || 'desconocido',
            nombreUsuario: userName || 'Anónimo',
            modulo: modulo || 'General',
            accion: accion || 'Acción',
            descripcion: descripcion || ''
        });
    } catch (error) {
        console.error("Error al registrar Audit Log:", error);
    }
};
